import ImageWithFallback from '@/globalComponents/image';
import Div from '@/shared/Div';
import Paragraph from '@/shared/Paragraph';
import Image from '@/shared/Image';
import React, { memo } from 'react';
import AppStore from '../../../public/images/appStoreBadge.svg';
import PlayStore from '../../../public/images/googlePlayBadge.png';
import Button from '@/shared/Button';
import classNames from 'classnames';
import withContentFlags from '@/hoc/withContentFlags';
import useScreen from '@/hooks/useScreen';

function AppDownloadCard({
  title,
  subtitle,
  playStoreUrl,
  appStoreUrl,
  image,
  background = '',
}: any) {
  const { isMobile, isTablet } = useScreen();
  return (
    <Div className={classNames('pt-s8 px-s5 md:py-s9 ', background)}>
      <Div
        // className="p-0.5 rounded-cs bg-neutral-50 cursor-pointer md:w-225 m-auto"
        className="p-0.5 rounded-cs bg-neutral-50 cursor-pointer max-w-screen-md md:mx-auto"
        style={{
          background,
        }}
      >
        <Div className="bg-white rounded-cs">
          <Div className="flex flex-col gap-s6 md:flex-row items-center md:items-start px-8 pt-10 md:px-10 md:pt-16 bg-white rounded-cs ">
            <Div className="flex flex-col gap-s7 items-center md:items-start">
              <Div className="flex flex-col gap-s3 text-center md:text-left">
                <Paragraph className="text-h-1 text-amc-brand md:text-hd-2">{title}</Paragraph>
                <Paragraph className="text-black/70 text-body-lg md:text-body-xl">
                  {subtitle}
                </Paragraph>
              </Div>
              <Div className="flex flex-col items-center">
                <Button href={appStoreUrl} theme="none">
                  <ImageWithFallback width={150} height={66} src={AppStore} alt="AppStore Icon" />
                </Button>
                <Button href={playStoreUrl} theme="none">
                  <ImageWithFallback width={175} height={75} src={PlayStore} alt="PlayStore Icon" />
                </Button>
              </Div>
            </Div>

            <Image
              alt=""
              quality={100}
              width={isMobile || isTablet ? 168 : 262}
              height={isMobile || isTablet ? 220 : 345}
              className="md:w-auto"
              cmsImage={image}
            />
          </Div>
        </Div>
      </Div>
    </Div>
  );
}

export default withContentFlags(memo(AppDownloadCard));
